import Particle from './Particles';
import './healthCare.css';
import { useEffect, useState } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { Carousel, Col, Modal, Row, Tabs } from 'antd';
import whoLogo1 from './assets/images/Patient-2.png';
import whoLogo2 from './assets/images/Payer-1.png';
import whoLogo3 from './assets/images/Provider-1.png';
import healthcare1 from './assets/images/Healthcare-1.png'
import healthcare2 from './assets/images/Healthcare-2.png'
import healthcare3 from './assets/images/Healthcare-3.png'
import healthcare4 from './assets/images/Healthcare-4.png'
import healthcare5 from './assets/images/Healthcare-5.png'
import service1 from './assets/images/service-1.webp'
import service2 from './assets/images/service-2.webp'
import service3 from './assets/images/service-3.webp'
import choose1 from './assets/images/choose-1.png'
import choose2 from './assets/images/choose-2.png'
import choose3 from './assets/images/choose-3.png'
import choose4 from './assets/images/choose-4.png'
import choose5 from './assets/images/choose-5.png'
import choose6 from './assets/images/choose-6.png'
import choose7 from './assets/images/choose-7.png'
import choose8 from './assets/images/choose-8.png'
import ehr1 from './assets/images/ehr-1.webp'
import ehr2 from './assets/images/ehr-2.webp'
import ehr3 from './assets/images/ehr-3.webp'
import ehr4 from './assets/images/ehr-4.png'
import ehr5 from './assets/images/ehr-5.svg'
import api2 from './assets/images/api-2.png'
import api3 from './assets/images/api-3.webp'
import api4 from './assets/images/api-4.png'
import wear1 from './assets/images/wear-1.png'
import wear2 from './assets/images/wear-2.png'
import wear3 from './assets/images/wear-3.webp'
import wear4 from './assets/images/wear-4.svg.png'
import wear5 from './assets/images/wear-5.png'
import wear6 from './assets/images/wear-6.webp'
import cloud1 from './assets/images/cloud-1.webp'
import cloud2 from './assets/images/cloud-2.webp'
import cloud3 from './assets/images/cloud-3.png'
import cloud4 from './assets/images/cloud-4.webp'
import project1 from './assets/images/project-1.png'
import project2 from './assets/images/project-2.png'
import project3 from './assets/images/project-3.png'
import project4 from './assets/images/project-4.png'
import project5 from './assets/images/project-5.png'
import project6 from './assets/images/project-6.png'
import project7 from './assets/images/project-7.png'
import compliance1 from './assets/images/compliance-1.png'
import compliance2 from './assets/images/compliance-2.png'
import compliance3 from './assets/images/compliance-3.png'
import compliance4 from './assets/images/compliance-4.png'
import compliance5 from './assets/images/compliance-5.png'
import './style.scss';



const HealthCare = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [capVal, setCapVal] = useState(null);
  const [email, setEmail] = useState(null);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setIsModalVisible(true);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value)
  }

  const onChangeTab = (key) => {
    console.log(key)
  }

  useEffect(() => {
    // Wrap every letter in a span
    var textWrapper = document.querySelector('.ml6 .letters');
    textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
    anime.timeline({ loop: true })
      .add({
        targets: '.ml6 .letter',
        translateY: ["1.1em", 0],
        translateZ: 0,
        duration: 750,
        delay: (el, i) => 50 * i
      }).add({
        targets: '.ml6',
        opacity: 0,
        duration: 1000,
        easing: "easeOutExpo",
        delay: 1000
      });
  }, []);

  const redirectHome = () => {
    window.open("https://www.markitech.ca", "_blank");
  }
  const redirectTraining = () => {
    window.open("https://markitech.ca/training/", "_blank");
  }
  const redirectStaffAugmentation = () => {
    window.open("https://markitech.ca/staff-augmentation/", "_blank");
  }
  const redirectPractice= () => {
    window.open("https://markitech.ca/pratice-optimization/", "_blank");
  }
  const redirectCalendar = ()=>{
    window.open("https://calendly.com/nauman-jaffar/30min", "_blank");
  }

  return (
    <>
      {/* Specific div with particle effect */}
      <div className="particle-container">
        <Particle />
      </div>

      {/* Other content */}
      <div className='main-heading-hc'>
        <h1 className="ml6">
          <span className="text-wrapper">
            <span className="letters large-font-hc">#1 North American-based Provider in Revolutionizing Healthcare with AI and Digital Solutions</span>
          </span>
        </h1>
        <button onClick={redirectHome} className='click-here-btn'>Get an instant Estimate for Your Project Idea</button>
        {/* <textarea
              onKeyPress={handleKeyPress}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              id="mainInput"
              className="custom-textarea"
              placeholder="Type here to generate a development plan and estimate in seconds with our custom software development solutions leveraging artificial intelligence technologies, machine learning, and AI applications for digital health and beyond."></textarea>
            <p className="press-enter-web">Press Enter to submit</p> */}
      </div>

      <Row className='pad-t-70'>
        <Col xl={4} xs={0} />
        <Col xl={16} xs={24}>
          {/* <img className='award-bg-width' alt="clientsBg" src={clientsBg} /> */}
          <h2 className='our-client-heading'>AI in Healthcare: Improving Patient Outcomes</h2>
          <p className='who-para'>
            We recognise that the needs of healthcare stakeholders vary widely, and we’re equipped to meet those diverse demands effectively
          </p>
        </Col>
        <Col xl={4} xs={0} />
        <Col xl={8} xs={24}>
          <div class="box">
            <div className='img-outer'>
              <div className='who-img-wrap'>
                <img className='who-img' src={whoLogo1} alt="whoLogo1" />
              </div>
            </div>
            <p className='who-name'>Patient​</p>
            <p className='who-para'>We empower patients with engagement solutions that enhance their control over their health, driving better outcomes. Our solutions boost communication, ensure medication adherence, and elevate patient satisfaction. By integrating advanced analytics, we provide personalized care that fosters long-term well-being.​</p>
          </div>
        </Col>
        <Col xl={8} xs={24}>
          <div class="box">
            <div className='img-outer'>
              <div className='who-img-wrap'>
                <img className='who-img' src={whoLogo2} alt="whoLogo1" />
              </div>
            </div>
            <p className='who-name'>Payer</p>
            <p className='who-para'>Optimize operations and reduce costs with our comprehensive payer solutions. Our healthcare IT services simplify transactions, enhance performance, and are tailored to meet your unique needs, ensuring scalability and future readiness. Leverage our expertise to stay ahead in a competitive healthcare landscape.​</p>
          </div>
        </Col>
        <Col xl={8} xs={24}>
          <div class="box">
            <div className='img-outer'>
              <div className='who-img-wrap'>
                <img className='who-img' src={whoLogo3} alt="whoLogo1" />
              </div>
            </div>
            <p className='who-name'>Provider</p>
            <p className='who-para'>Enhance patient care and streamline your clinic and hospital operations with our provider services. From electronic health records to robotic process automation or practice optimization to telemedicine and remote monitoring, our advanced technologies are designed to elevate your practice’s efficiency and impact​</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl={4} xs={0} />
        <Col xl={16} xs={24}>
          {/* <img className='award-bg-width' alt="clientsBg" src={clientsBg} /> */}
          <h2 className='our-client-heading'>Problems We Solve</h2>
        </Col>
        <Col xl={4} xs={0} />
        <Col xl={2} xs={0} />
        <Col className='pad-15' xl={4} xs={24}>
          <div className='choose-box choose-box-problem pad-30'>
            <p className='choose-name'>Access to Care and Patient Engagement</p>
            <p className='choose-para'>We enhance patient access to healthcare through telemedicine, remote monitoring, and personalized care plans. Our solutions improve patient engagement and lead to better health outcomes.​</p>
          </div>
        </Col>
        <Col className='pad-15' xl={4} xs={24}>
          <div className='choose-box choose-box-problem pad-30'>
            <p className='choose-name'>Operational Efficiency for Providers​</p>
            <p className='choose-para'>We automate administrative tasks and streamline workflows using AI and RPA solutions. This allows healthcare providers to dedicate more time to patient care, improving overall efficiency.​</p>
          </div>
        </Col>
        <Col className='pad-15' xl={4} xs={24}>
          <div className='choose-box choose-box-problem pad-30'>
            <p className='choose-name'>Data-Driven Decision Making</p>
            <p className='choose-para'>Our AI and machine learning tools provide actionable insights that aid in early risk detection, better resource management, and improved clinical decision-making.​</p>
          </div>
        </Col>
        <Col className='pad-15' xl={4} xs={24}>
          <div className='choose-box choose-box-problem pad-30'>
            <p className='choose-name'>Cost Reduction and Fraud Prevention for Payers</p>
            <p className='choose-para'>We optimize processes to reduce operational costs, improve utilization management, and prevent fraud using predictive analytics, ensuring a more efficient and secure system for payers.​</p>
          </div>
        </Col>
        <Col className='pad-15' xl={4} xs={24}>
          <div className='choose-box choose-box-problem pad-30'>
            <p className='choose-name'>Interoperability and Data Security</p>
            <p className='choose-para'>We ensure seamless data exchange between systems while maintaining strict compliance with data privacy regulations. This enhances healthcare collaboration and secures sensitive data.​</p>
            </div>
        </Col>
        <Col xl={1} xs={0} />
      </Row>
      <Row className='pad-t-70'>
      <Col className='App' xl={24} xs={24}>
        <button onClick={redirectStaffAugmentation} className='click-here-btn m-t-0'>Access Top Tech & Healthcare Talent – Explore Our Services Now!</button>
        </Col>
        <Col xl={24} xs={24}>
          <h2 className='our-client-heading'>Digital Transformation in Healthcare Services</h2>
          <p className='who-para'>
            We understand that choosing the right healthcare IT partner is crucial. Here's what sets us apart
          </p>
        </Col>
        <Col xl={3} xs={0} />
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose1} alt="choose1" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 1 </span>
            <p className='choose-name'>Domain expertise and experience​</p>
            <p className='choose-para'>Benefit from our deep industry knowledge and expertise gained through years of dedicated experience in healthcare IT.​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose2} alt="choose2" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 2 </span>
            <p className='choose-name'>Develop your own customised solutions​</p>
            <p className='choose-para'>Our healthcare IT solutions are designed to address your specific challenges and objectives, ensuring optimal performance​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose3} alt="choose3" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 3 </span>
            <p className='choose-name'>Seamless integration into existing platforms​</p>
            <p className='choose-para'>Experience hassle-free integration with existing systems and the flexibility to scale as your needs evolve without disruption​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose4} alt="choose4" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 4 </span>
            <p className='choose-name'>Quality and Compliance Assurance​</p>
            <p className='choose-para'>Our healthcare IT solutions adhere to the highest standards of compliance and security, safeguarding your sensitive data​</p>
          </div>
        </Col>
        <Col xl={2} xs={0} />
        <Col xl={3} xs={0} />
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose5} alt="choose5" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 5 </span>
            <p className='choose-name'>Design Thinking-Led Approach​</p>
            <p className='choose-para'>We approach every project with a design-thinking mindset, prioritising user experience and engagement to drive successful outcomes​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose6} alt="choose6" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 6 </span>
            <p className='choose-name'>White-Label Solutions​</p>
            <p className='choose-para'>Reduce time to market by using white label solutions that are available, and focus on core competencies to drive innovation.​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose7} alt="choose7" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 7 </span>
            <p className='choose-name'>Practice optimisation via robotic process automation​</p>
            <p className='choose-para'>Embrace automation for efficient workflows and better care. Our healthcare IT solutions minimise errors and optimise resources, enhancing quality​</p>
          </div>
        </Col>
        <Col className='choose-box-wrap' xl={4} xs={24}>
          <div className='choose-img-wrap'>
            <img className='choose-img' src={choose8} alt="choose8" />
          </div>
          <div className='choose-box'>
            <span className='choose-number'> 8 </span>
            <p className='choose-name'>Flexible pricing structures​</p>
            <p className='choose-para'>Our flexible pricing structures are clear and transparent, ensuring you understand exactly what you’re investing in—no hidden costs or surprises</p>
          </div>
        </Col>
        <Col xl={5} xs={0} />
      </Row>
      <Row>
        <Col className='App' xl={24} xs={24}>
        <button onClick={redirectTraining} className='click-here-btn m-t-0'>Enhance Your Skills with AI – Sign Up for Free Training Today!</button>
        </Col>
      </Row>
      <Row className='pad-t-70'>
        <Col className='our-work-bg-color' xl={24} xs={24}>
          <Row>
            <Col xl={4} xs={0} />
            <Col xl={16} xs={24}>
              <h2 className='offer-heading'>Enhancing Healthcare Efficiency with Automation</h2>
              <p className='offer-para'>
                Enhance patient care and optimise healthcare operations with our tailored IT solutions. From electronic medical records (EMR) integration to telemedicine, we provide everything you need to meet your specific goals.
              </p>
            </Col>
            <Col xl={4} xs={0} />
            <Col xl={3} xs={0} />
            <Col xl={18} xs={0}>
              <Carousel arrows={false} autoplay={true} autoplaySpeed={2000} slidesToShow={2} >
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={4}>
                        <img className='service-img' src={service1} alt="service1" />
                      </Col>
                      <Col xl={20}>
                        <p className='service-name'>Remote patient monitoring (RPM) White Label Solution​</p>
                        <p className='service-para'>Our Remote Patient Monitoring (RPM) White Label Solution enables healthcare providers to offer personalised care to patients from the comfort of their homes. We provide a fully customizable platform that seamlessly integrates with your brand, offering real-time health monitoring, data analytics, and patient engagement tools. With our solution, you can track patient vitals, manage chronic conditions, and intervene early when necessary, all while enhancing patient satisfaction and improving outcomes​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={4}>
                        <img className='service-img' src={service2} alt="service2" />
                      </Col>
                      <Col xl={20}>
                        <p className='service-name'>Telemedicine Application Development ​</p>
                        <p className='service-para'>Our Telemedicine Application Development service empowers healthcare providers to extend their reach and offer high-quality care beyond traditional settings. We create customised user-friendly telemedicine platforms that include secure video consultations, appointment scheduling, electronic health records (EHR) integration, and real-time communication tools. Whether you’re looking to enhance patient access, reduce healthcare delivery costs, or improve care coordination, our solutions are designed to fit your specific needs and provide a seamless virtual care experience​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={4}>
                        <img className='service-img' src={service3} alt="service3" />
                      </Col>
                      <Col xl={20}>
                        <p className='service-name'>Develop mental and digital health app solutions​</p>
                        <p className='service-para'>Our mental and digital health app solutions are designed to support a wide range of needs, from managing mental health conditions to promoting overall well-being. We develop customised apps that offer features like mood tracking, cognitive-behavioural therapy (CBT) tools, meditation guides, and digital counseling.  These apps integrate seamlessly with existing healthcare systems and can be tailored to specific patient populations or healthcare providers, ensuring effective, personalised care. Our solutions help improve patient outcomes, enhance engagement, and provide valuable insights through data-driven analytics.​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Carousel>
            </Col>
            <Col xl={0} xs={24}>
              <Carousel arrows={false} autoplay={true} autoplaySpeed={2000} slidesToShow={1} >
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={0} xs={6} />
                      <Col xl={4} xs={12}>
                        <img className='service-img' src={service1} alt="service1" />
                      </Col>
                      <Col xl={0} xs={6} />
                      <Col xl={20} xs={24}>
                        <p className='service-name'>Remote patient monitoring (RPM) White Label Solution​</p>
                        <p className='service-para'>Our Remote Patient Monitoring (RPM) White Label Solution enables healthcare providers to offer personalised care to patients from the comfort of their homes. We provide a fully customizable platform that seamlessly integrates with your brand, offering real-time health monitoring, data analytics, and patient engagement tools. With our solution, you can track patient vitals, manage chronic conditions, and intervene early when necessary, all while enhancing patient satisfaction and improving outcomes​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={0} xs={6} />
                      <Col xl={4} xs={12}>
                        <img className='service-img' src={service2} alt="service2" />
                      </Col>
                      <Col xl={0} xs={6} />
                      <Col xl={24} xs={24}>
                        <p className='service-name'>Telemedicine Application Development ​</p>
                        <p className='service-para'>Our Telemedicine Application Development service empowers healthcare providers to extend their reach and offer high-quality care beyond traditional settings. We create customised user-friendly telemedicine platforms that include secure video consultations, appointment scheduling, electronic health records (EHR) integration, and real-time communication tools. Whether you’re looking to enhance patient access, reduce healthcare delivery costs, or improve care coordination, our solutions are designed to fit your specific needs and provide a seamless virtual care experience​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className='flex-center'>
                  <div className='service-box'>
                    <Row>
                      <Col xl={0} xs={6} />
                      <Col xl={4} xs={12}>
                        <img className='service-img' src={service3} alt="service3" />
                      </Col>
                      <Col xl={0} xs={6} />
                      <Col xl={20} xs={24}>
                        <p className='service-name'>Develop mental and digital health app solutions​</p>
                        <p className='service-para'>Our mental and digital health app solutions are designed to support a wide range of needs, from managing mental health conditions to promoting overall well-being. We develop customised apps that offer features like mood tracking, cognitive-behavioural therapy (CBT) tools, meditation guides, and digital counseling.  These apps integrate seamlessly with existing healthcare systems and can be tailored to specific patient populations or healthcare providers, ensuring effective, personalised care. Our solutions help improve patient outcomes, enhance engagement, and provide valuable insights through data-driven analytics.​</p>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Carousel>
            </Col>
            <Col xl={3} xs={0} />
          </Row>
        </Col>
      </Row>
      <Row className='pad-t-70'>
      <Col className='App' xl={24} xs={24}>
        <button onClick={redirectPractice} className='click-here-btn m-t-0'>Streamline Your Clinical Workflow with AI – Start Optimizing Today!</button>
        </Col>
        <Col xl={24} xs={24}>
          <h2 className='our-client-heading'>Integration Expertise</h2>
        </Col>
        <Col xl={3} xs={0} />
        <Col xl={18} xs={24}>
          <Tabs centered={true} className='ant-tabs-content-holder ant-tabs-nav-wrap' onChange={onChangeTab} type="card">
            <Tabs.TabPane tab="EHRs" key="1">
              <div className='flex-center'>
                <Row>
                  <Col xl={4}>
                    <img alt="ehr-1" src={ehr1} />
                  </Col>
                  <Col xl={5}>
                    <img alt="ehr-2" src={ehr2} />
                  </Col>
                  <Col xl={5}>
                    <img alt="ehr-3" src={ehr3} />
                  </Col>
                  <Col xl={5}>
                    <img className='ehr-img-4' alt="ehr-4" src={ehr4} />
                  </Col>
                  <Col xl={5}>
                    <img className='ehr-img-5' alt="ehr-5" src={ehr5} />
                  </Col>
                </Row>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="APIs" key="2">
              <div className='flex-center'>
                <Row>
                  <Col xl={6}>
                    <img className='ehr-img-5 api-img1' alt="ehr-5" src={ehr5} />
                  </Col>
                  <Col xl={6}>
                    <img className='api-img2' alt="ehr-2" src={api2} />
                  </Col>
                  <Col xl={6}>
                    <img className='api-img3' alt="api-3" src={api3} />
                  </Col>
                  <Col xl={6}>
                    <img className='ehr-img-4' alt="api-4" src={api4} />
                  </Col>
                </Row>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Wearables" key="3">
              <div className='flex-center'>
                <Row>
                  <Col xl={8}>
                    <img className='ehr-img-5 wear-img-1' alt="wear-1" src={wear1} />
                  </Col>
                  <Col xl={8}>
                    <img className='ehr-img-5 wear-img-1' alt="wear-4" src={wear4} />
                  </Col>
                  <Col xl={8}>
                    <img className='api-img3' alt="wear-3" src={wear3} />
                  </Col>
                  <Col xl={8}>
                    <img className='api-img2 wear-img-2' alt="wear-2" src={wear2} />
                  </Col>
                  <Col xl={8}>
                    <img className='api-img2 wear-img-2' alt="wear-5" src={wear5} />
                  </Col>
                  <Col xl={8}>
                    <img className='wear-img-6' alt="wear-6" src={wear6} />
                  </Col>
                </Row>
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Cloud" key="4">
              <div className='flex-center'>
                <Row>
                  <Col xl={8}>
                    <img className='ehr-img-5 wear-img-1 padd-t-54' alt="cloud-1" src={cloud1} />
                  </Col>
                  <Col xl={8}>
                    <img className='api-img3 pad-t-60' alt="cloud-3" src={cloud3} />
                  </Col>
                  <Col xl={8}>
                    <img className='api-img2 cloud-img-3' alt="cloud-2" src={cloud2} />
                  </Col>
                  <Col xl={24}>
                    <img className='api-img2 cloud-img-4' alt="cloud-4" src={cloud4} />
                  </Col>
                </Row>
              </div>
            </Tabs.TabPane>
          </Tabs>
        </Col>
        <Col xl={3} xs={0} />
      </Row>
      <Row className='pad-t-70'>
        <Col xs={0} xl={3} />
        <Col xl={18} xs={24}>
          <h2 className='our-client-heading'>Compliance Services</h2>
          <p className='compliance'>
            Our developers are certified in HIPAA/PHIPA/PIPEDA/OTN and well-versed in healthcare regulations like GDPR. We specialise in creating HIPAA-compliant solutions that ensure the highest levels of security and regulatory compliance. Count on us to deliver robust healthcare software that safeguards patient data effectively.
          </p>
        </Col>
        <Col xs={0} xl={3} />
        <Col xl={24} xs={0}>
          <Carousel arrows={true} slidesToShow={5} autoplay>
            <div className='flex-center'>
              <img className='width-60' alt="compliance1" src={compliance1} />
            </div>
            <div className='flex-center'>
              <img className='width-60' alt="compliance2" src={compliance2} />
            </div>
            <div className='flex-center'>
              <img className='width-60' alt="compliance3" src={compliance3} />
            </div>
            <div className='flex-center'>
              <img className='width-60' alt="compliance4" src={compliance4} />
            </div>
            <div className='flex-center'>
              <img className='width-60' alt="compliance5" src={compliance5} />
            </div>
          </Carousel>
        </Col>
        <Col xl={0} xs={24}>
          <Carousel arrows={true} slidesToShow={1} autoplaySpeed={1000} autoplay>
          <div className='flex-center'>
              <img className='width-80' alt="compliance1" src={compliance1} />
            </div>
            <div className='flex-center'>
              <img className='width-80' alt="compliance2" src={compliance2} />
            </div>
            <div className='flex-center'>
              <img className='width-80' alt="compliance3" src={compliance3} />
            </div>
            <div className='flex-center'>
              <img className='width-80' alt="compliance4" src={compliance4} />
            </div>
            <div className='flex-center'>
              <img className='width-80' alt="compliance5" src={compliance5} />
            </div>
          </Carousel>
        </Col>
        <Col className='App' xl={24} xs={24}>
        <button onClick={redirectCalendar} className='click-here-btn'>Book a Consultation for Personalized Services</button>
        </Col>
      </Row>
      
      <Row className='pad-t-70 bg-project'>
        <Col xl={3} xs={0} />
        <Col xl={18} xs={24}>
          <p className='project-heading'>Our Projects</p>
          <h2 className='project-para'>
            A Glance of Our Work
          </h2>
        </Col>
        <Col xl={3} xs={0} />
        <Col xl={3} xs={0} />
        <Col xl={18} xs={0}>
          <Carousel arrows={false} slidesToShow={3} autoplay={true}>
            <div className='carousel-item'>
              <img className='width-35' alt="project-1" src={project1} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Your Doctors Online</h3>
                  <p className="project-desc">Healthcare App For Online Doctor Consultation</p>
                </span>
              </div>
            </div>
            <div className='carousel-item pad-tb-18'>
              <img className='width-100' alt="project-2" src={project2} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Carefall</h3>
                  <p className="project-desc">AI Predictions For Seniors With Early Dementia</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-35' alt="project-3" src={project3} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>SenSights.AI</h3>
                  <p className="project-desc">Healthcare Focused Analytics and Insights</p>
                </span>
              </div>
            </div>
            <div className='carousel-item pad-tb-16'>
              <img className='width-100' alt="project-4" src={project4} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Alembico</h3>
                  <p className="project-desc">EMR to Diagnose Diseases</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-5" src={project5} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>DiabetesPredict.AI</h3>
                  <p className="project-desc">Predicting Probability of Chronic Diseases So It Can Be Avoided</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-62' alt="project-6" src={project6} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Veyetals</h3>
                  <p className="project-desc">Real-time health monitoring system using IoT</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-7" src={project7} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Safe2Work</h3>
                  <p className="project-desc">Infection & Covid19 Risk Assessment</p>
                </span>
              </div>
            </div>
          </Carousel>
        </Col>
        <Col xl={3} xs={0} />
        <Col xl={0} xs={24}>
          <Carousel arrows={false} slidesToShow={1} autoplay>
            <div className='carousel-item'>
              <img className='width-35' alt="project-1" src={project1} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Your Doctors Online</h3>
                  <p className="project-desc">Healthcare App For Online Doctor Consultation</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-2" src={project2} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Carefall</h3>
                  <p className="project-desc">AI Predictions For Seniors With Early Dementia</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-35' alt="project-3" src={project3} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>SenSights.AI</h3>
                  <p className="project-desc">Healthcare Focused Analytics and Insights</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-4" src={project4} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Alembico</h3>
                  <p className="project-desc">EMR</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-5" src={project5} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>DiabetesPredict.AI</h3>
                  <p className="project-desc">Predicting Probability of Chronic Diseases So It Can Be Avoided</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-62' alt="project-6" src={project6} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Veyetals</h3>
                  <p className="project-desc">Real-time health monitoring system using IoT</p>
                </span>
              </div>
            </div>
            <div className='carousel-item'>
              <img className='width-100' alt="project-7" src={project7} />
              <div className='overlay'>
                <span className='overlay-text'>
                  <h3 className='project-heading'>Safe2Work</h3>
                  <p className="project-desc">Infection & Covid19 Risk Assessment</p>
                </span>
              </div>
            </div>
          </Carousel>
        </Col>
      </Row>
      
      <Row>
        <Col xl={2} xs={0} />
        <Col xl={20} xs={24}>
          {/* <img className='award-bg-width' alt="clientsBg" src={clientsBg} /> */}
          <h2 className='healthcare-heading'>Healthcare Digital Transformation Services</h2>
          <Row className='pad-t-70'>
            <Col xl={2} xs={8} >
              <img className='width-80' src={healthcare1} alt="healthcare1" />
            </Col>
            <Col xl={3} xs={16}>
              <p className='healthcare-title'>Discovery & Design Thinking</p>
            </Col>
            <Col xl={2} xs={8}>
              <img className='width-80' src={healthcare2} alt="healthcare2" />
            </Col>
            <Col xl={3} xs={16}>
              <p className='healthcare-title'>Custom app development</p>
            </Col>
            <Col xl={2} xs={8}>
              <img className='width-80' src={healthcare3} alt="healthcare3" />
            </Col>
            <Col xl={3} xs={16}>
              <p className='healthcare-title'>Robotic Process Automation</p>
            </Col>
            <Col xl={2} xs={8}>
              <img className='width-80' src={healthcare4} alt="healthcare4" />
            </Col>
            <Col xl={2} xs={16}>
              <p className='healthcare-title'>DevOps</p>
            </Col>
            <Col xl={2} xs={8}>
              <img className='width-80' src={healthcare5} alt="healthcare5" />
            </Col>
            <Col xl={3} xs={16}>
              <p className='healthcare-title'>Code review, QA, and testing</p>
            </Col>
          </Row>
        </Col>
        <Col xl={2} xs={0} />
      </Row>


    </>
  );

}
export default HealthCare;